import { setupInfiniteHScrolling } from "./js/infiniteHScroll";
import { setupScrollToElement } from "./js/scrollToElement";
import { setupStackCard } from "./js/stackCard";

document.addEventListener("DOMContentLoaded", () => {
  setupStackCard();
  setupInfiniteHScrolling();
  setupScrollToElement();
  setupFormSubmission();
});

function setupFormSubmission() {
  const submitButton = document.getElementById("form-submit-button");
  const successMessage = document.getElementById("success-message");
  const form = submitButton?.closest("form") || submitButton?.parentElement?.closest('div[class*="flex-col"]'); // Try to find form or parent div

  if (submitButton && successMessage && form) {
    submitButton.addEventListener("click", (event) => {
      event.preventDefault(); // Prevent default form submission

      // Assuming your form has input fields you might want to clear or process
      const fullNameInput = document.getElementById("fullName");
      const phoneNumberInput = document.getElementById("phoneNumber");

      // Basic validation example (optional)
      if (fullNameInput.value.trim() === "" || phoneNumberInput.value.trim() === "") {
        // alert("Please fill in all fields."); // Or display a more subtle error
        // return;
      }

      // Display the success message
      successMessage.classList.remove("hidden");

      // Optional: Clear form fields after submission
      if (fullNameInput) fullNameInput.value = "";
      if (phoneNumberInput) phoneNumberInput.value = "";

      // Optional: Hide the message after a few seconds
      setTimeout(() => {
        successMessage.classList.add("hidden");
      }, 5000); // Hide after 5 seconds
    });
  } else {
    if (!submitButton) console.error("Submit button not found");
    if (!successMessage) console.error("Success message element not found");
    if (!form) console.error("Form or form container not found to attach event listener for submission logic. The button's parent is:", submitButton?.parentElement);
  }
}
